import React, { FC, ReactElement, ReactNode } from 'react'

export interface HeadingProps {
  title: string
}
export const Heading = ({ title }: HeadingProps) => {
  return <div>{title}</div>
}

export const List: <ListItem>({
  items,
  render
}: {
  items: ListItem[]
  render: (item: ListItem) => ReactNode
}) => ReactElement = ({ items, render }) => {
  return (
    <ul>
      {items.map((item, index) => (
        <li key={index}>{render(item)}</li> // eslint-disable-line react/no-array-index-key
      ))}
    </ul>
  )
}

const TestComponent: FC = function () {
  const listToRender = ['aaa', 'bbb', 'ccc']

  return (
    <div>
      <Heading title="> render a list of data" />
      <List items={listToRender} render={(str) => <strong>{str}</strong>} />
    </div>
  )
}

export default TestComponent
